<template>
    <!-- =================================================================== -->
    <!-- show merge btn if the log is merged request -->
    <div v-if="showButton">
        <v-btn small style="margin-right: 140px;" color="primary" @click="handleClick">
            <v-icon left small>mdi-eye-outline</v-icon>
            عرض الطلب الذى تم دمجه
        </v-btn>
    </div>
    <!-- end of show merge btn if the log is merged request -->
    <!-- =================================================================== -->
</template>
<script>
export default {
    name: 'MergedRequestBtn',
    props: {
        item: {
            type: Object,
            required: true
        },
        showButton: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleClick() {
            // استدعاء الفنكشن من الصفحة الأب
            this.$emit("view-merged", this.item);
        }
    }
};
</script>